<script>
import { mapActions } from "vuex";

export default {
  props: {
    companyId: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      licence: null,

      selectedAppModules: [],

      selectedOptionalAppModules: [],

      allAppModules: [],
      optionalAppModules: [],

      alreadyIncludedIDs: [],
    }
  },

  computed: {
    reactiveOptionalAppModulesData() {
      return this.optionalAppModules;
    },

    isActive() {
      return this.$user.role_id === 1;
    },

    fixedCompanyId() {
      if (!this.companyId) return this.$user.company_id;
      return this.companyId;
    },
  },

  async mounted() {
    await this._getCompanyLicence();
    await this._getAllModules();
    await this._getAppModules();
  },

  methods: {
    ...mapActions('company', [
      'getCompanyLicence',
      'updateCompanyLicence',
      'updateCompanyLicenceStatus',
      'updateCompanyLicenceEndDate',
      'getAppModules',
      'getAllModules',
    ]),

    async _getCompanyLicence() {
      this.getCompanyLicence({company_id: this.fixedCompanyId})
        .then(res => {
          this.licence = res.data[0];

          const date = new Date(res.data[0].licence_end_date);
          const formatted = date.toISOString().split("T")[0]

          Object.assign(this.licence, {'formatted_end_date': formatted});
        })
        .catch(() => {
          console.error('Error fetching company licence!');
        })
    },

    async _updateCompanyLicence() {
      if (!this.isActive) 
        return;

      let params = {
        company_licence_id: this.licence.company_licence_id,
        plan_id: !this.licence ? 1 : this.licence.plan_id,
        updated_by: this.$user.user_id
      }

      this.optionalAppModules.forEach((item, index) => {
        if (item.included) {
          params[`optional_module_${index+1}_id`] = item.module_id;
        } else if (!item.included) {
          params[`optional_module_${index+1}_id`] = null;
        }
      });

      await this.updateCompanyLicence(params)
        .then((res) => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.emitFunctionResolve();
        })
    },
    async _getAppModules() {
      const params = {
        plan_id: !this.licence ? 1 : this.licence.plan_id,
      }
      let modules = [];
      await this.getAppModules(params)
        .then(res => {
          modules = res.data;
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
      
      this.selectedAppModules = modules;
    },
    async _getAllModules() {
      if (this.licence) {
        this.alreadyIncludedIDs = [
          this.licence.optional_module_1_id,
          this.licence.optional_module_2_id, 
          this.licence.optional_module_3_id, 
          this.licence.optional_module_4_id,
        ];
      }

      const params = {
        is_deleted: false,
      }
      let modules = [];
      await this.getAllModules(params)
        .then(res => {
          modules = res.data;
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.optionalAppModules = modules.filter( item => item.plan_id === null);
          this.optionalAppModules.forEach( (item, index) => {
            this.$set(item, "included", this.alreadyIncludedIDs[index]);
          });
        })
      
      this.allAppModules = modules;
    },
    async _updateCompanyLicenceStatus() {
      if (!this.isActive) 
        return;

      try {
        if (this.licence.licence_status == "ACTIVE") {
          this.licence.licence_status = "PASSIVE";
        } else if (this.licence.licence_status == "PASSIVE") {
          this.licence.licence_status = "ACTIVE";
        } else {
          throw new Error("Invalid Licence Status Input!");
        }
      } catch (error) {
        console.error(error);
      } finally {
        const params = {
          company_licence_id: this.licence.company_licence_id,
          licence_status: this.licence.licence_status,
          updated_by: this.$user.user_id
        };
      
        this.updateCompanyLicenceStatus(params)
          .then( res => {
            this.$notify('success', res.data.messageName);
          })
          .catch(({ response }) => {
            this.$notify('error', response.data.messageName);
          })
          .finally(() => {
            this.emitFunctionResolve();
          })
      }
    },
    async _updateCompanyLicenceEndDate() {
      if (!this.isActive) 
        return;

      const params = {
        company_licence_id: this.licence.company_licence_id,
        licence_end_date: this.licence.formatted_end_date,
        updated_by: this.$user.user_id
      };
    
      this.updateCompanyLicenceEndDate(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.emitFunctionResolve();
        })
    },

    emitFunctionResolve() {
      this.$emit('update', this.licence);
    },

    async selectPlan(id) {
      if (!this.isActive) 
        return;

      const setPlan = async (id) => {
        this.licence.plan_id = id;
        if (id === 1) {
          this.licence.plan_name = 'Starter';
        } else if (id === 2) {
          this.licence.plan_name = 'Standard';
        } else if (id === 3) {
          this.licence.plan_name = 'Premium';
        } else if (id === 4) {
          this.licence.plan_name = 'Enterprise';
        }
      }
      await setPlan(id);
      await this._getAppModules();
    },

    selectOptionalModule(item) {
      item.included = !item.included;
    },

    isIncluded(item) {
      return item.included;

      /* for (let i = 1; i <= 4; i++) {
        const is_included = this.licence[`optional_module_${i}_id`] == item.module_id;
        if (is_included) return true;
      }

      return false; */
    },

    openUpdateEndDatePopup() {
      if (this.isActive) this.$refs.updateEndDate.openPopup();
    },
  }
}
</script>

<template>
  <div class="plans-modules-container" v-if="licence">
    <div class="smaller-container plans-container">

      <div class="licence-status" 
        :style="{color: licence.licence_status == 'ACTIVE' ? 'white' : 'white', 
              backgroundColor: licence.licence_status == 'ACTIVE' ? 'var(--sustainfinity-green)' : '#b40000'}"
        @click="_updateCompanyLicenceStatus"
        :class="{'--inactive-container': !isActive}"  
      >
        {{ licence.licence_status }}
      </div>
      
      <div class="plan-header">
        {{ $t('companyLicence.header') }}
      </div>
      
      <div class="current-plan">
        <b>{{ $t('companyLicence.current') }}</b>&nbsp;{{ licence.plan_name }}
      </div>
      
      <div class="plan-dates">  
        <b>
          {{ $t('companyLicence.start') }}: {{ licence.licence_start_date | dateFormat }} 
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span @click="openUpdateEndDatePopup()">{{ $t('companyLicence.end') }}: {{ licence.licence_end_date | dateFormat }}</span>
        </b>
      </div>

      <div class="plan-types">
        <div class="plan-type" :class="{'selected-plan': licence.plan_id == 1, '--inactive-container': !isActive}" @click="selectPlan(1)">
          Starter
        </div>
        
        <div class="plan-type" :class="{'selected-plan': licence.plan_id == 2, '--inactive-container': !isActive}" @click="selectPlan(2)">
          Standard
        </div>
      </div>
      <div class="plan-types">
        <div class="plan-type" :class="{'selected-plan': licence.plan_id == 3, '--inactive-container': !isActive}" @click="selectPlan(3)">
          Premium
        </div>
        <div class="plan-type" :class="{'selected-plan': licence.plan_id == 4, '--inactive-container': !isActive}" @click="selectPlan(4)">
          Enterprise
        </div>
      </div>

    </div>
    
    <div class="smaller-container modules-container">
      <div class="modules-header">
        <b>{{ $t('companyLicence.modules') }}</b>
      </div>

      <div v-for="item in selectedAppModules" :key="item" class="module">
        {{ item.module_name }} <i class="modules-check fa-regular fa-circle-check"></i> 
      </div>
      <div v-for="item in optionalAppModules" @click="selectOptionalModule(item)" :key="item" class="module"
        style="cursor: pointer;" :class="{'included-module': isIncluded(item), 'optional-module': !isIncluded(item), '--inactive-container': !isActive}"
      >
        {{ item.module_name }} <i class="modules-check fa-regular fa-circle-check" style="cursor: pointer;" :class="{'included-module-check': isIncluded(item), 'optional-module-check': !isIncluded(item)}"></i> 
      </div>
    </div>
    
    <button
      v-if="isActive"
      class="sust-btn sust-btn-green"
      style="position: absolute; bottom: .5em; right: .5em;"
      @click="_updateCompanyLicence()"
    >
      {{ $t('companyLicence.upgrade') }}
    </button>
    <a 
      v-else 
      href="https://www.sustainfinity.com/support" target="_blank"
      class="sust-btn sust-btn-green"
      style="position: absolute; bottom: .5em; right: .5em; color: whitesmoke !important;"
    >
      {{ $t('companyLicence.contact_us') }}
    </a>

    <sust-popup
      ref="updateEndDate"
      title="Update Licence End Date"
      size="xs"
      @ok="_updateCompanyLicenceEndDate()"
    >
      <input class="flex-all-centered-row" type="date" v-model="licence.formatted_end_date">
    </sust-popup>

  </div>
</template>

<style scoped lang="scss">
  * {
    color: var(--sustainfinity-navy);
  }

  .--inactive-container {
    pointer-events: none !important;
  }

  .plans-modules-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    background: white;
    position: relative;
    justify-content: center;

    padding-bottom: 2em;

    box-shadow: 0 .1em .5em .25em gray;
    border-radius: 1em;
  }

  .plans-container {
    flex: 1;
    padding: 1em;
    border-right: .25em solid var(--sustainfinity-navy);
    height: fit-content;
  }
  .modules-container {
    padding: 1em;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .plan-types {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }
  .plan-type {
    flex: 1;
    border: .1em solid var(--sustainfinity-navy);
    border-radius: .5em;
    margin: .33em;
    height: 5em;

    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;

    font-size: 1.5rem;
    font-weight: bold;
    color: var(--sustainfinity-blue);

    cursor: pointer;

    &:hover {
        box-shadow: 0 0 .33em .33em #c3dee5 inset;
        color: var(--sustainfinity-green);
    }
  }

  .plan-header {
    padding-left: .33em;
    font-size: 1.75em;
    font-weight: bold;
  }

  .current-plan, .plan-dates {
    padding-left: .33em;
    font-size: 1.1em;
  }

  .previous-section {
    background-color: var(--sustainfinity-faded-blue);
    border-radius: .5em;
  }

  .previous-section-header {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: .5em;
  }

  .selected-plan {
    background-color: var(--sustainfinity-faded-blue);
    box-shadow: 0 0 .33em .33em #c3dee5 inset;
    border-color: var(--sustainfinity-blue);
    color: var(--sustainfinity-navy);
  }

  .modules-header {
    font-size: 1.75em;
  }

  .module{
    width: 100%;
    padding: .66em;
    font-weight: bold;
    font-size: 1.15em;

    position: relative;

    & > .modules-check {
      position: absolute;
      font-size: 1.33em;

      right: 1em;

      top: 50%;
      transform: translateY(-50%);
    }
  }
  .module:nth-of-type(odd) {
    background-color: var(--sustainfinity-faded-blue);
    border-radius: 1em;
  }

  .optional-module {
    color: rgba(3, 132, 171, 0.5);
  }

  .optional-module-check {
    color: rgba(68, 169, 0, 0.5);

    cursor: pointer;
    &:hover {
      filter: brightness(140%);
    }
  }
  
  .included-module {
    color: var(--sustainfinity-blue);
  }

  .included-module-check {
    color: var(--sustainfinity-green);

    cursor: pointer;
    &:hover {
      filter: brightness(120%);
    }
  }

  .smaller-container {
    position: relative;

    & > .licence-status {
      position: absolute;
      right: 5%;
      top: 5%;

      font-size: 1.25em;
      font-weight: bold;

      padding: .2em;
      border-radius: .4em;

      box-shadow: 0 0 .25em .1em darkgray;

      cursor: pointer;
      &:hover {
        filter: brightness(105%);
      }
    }
  }

</style>